import TimeUpModal, { TimeUpModalProps } from './TimeUpModal';

export default TimeUpModal;
export type { TimeUpModalProps };
